import React from "react";

function SessionExpired({ signOut, showRestrictedExpirationMessage }) {
  const renderMainMessage = () => {
    if (showRestrictedExpirationMessage) {
      return (
        <p className="copy">Your access has already expired. Please generate a new one.</p>        
      )
    }

    return <p className="copy">Please Login to continue</p>        

  }

  return (
    <div className="ds-container">
      <div className="grid">
        <div className="ds-card ds-fullPagePrompt">
          <div className="cardSection _eventPrompt">
            <i className="materialIcon --large">announcement</i>
            <h1 className="subhead">Session Expired</h1>
            {renderMainMessage()}
          </div>
          {!showRestrictedExpirationMessage && (
            <a onClick={signOut} className="ds-btn --full">Login</a>
          )}
        </div>
      </div>
    </div>
  )
}

export default SessionExpired;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/SessionExpired.js